import styled from 'styled-components';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';
import { FilterStyles } from '../../../search-new/components/filters-menu/FilterWrapper';
import QuickFilter from './QuickFilterChip';

interface QuickFilterProps {
  areas: any[];
  compounds: any[];
  developers: any[];
}

const QuickFilters = ({ areas, compounds, developers }: QuickFilterProps) => {
  const quickFilters = [
    {
      filterName: 'areas',
      filterType: SearchFiltersTypes.AREAS,
      filterOptions: areas,
      filterStyle: FilterStyles.CHECKBOX
    },
    {
      filterName: 'compounds',
      filterType: SearchFiltersTypes.COMPOUNDS,
      filterOptions: compounds,
      filterStyle: FilterStyles.CHECKBOX
    },
    {
      filterName: 'developers',
      filterType: SearchFiltersTypes.DEVELOPERS,
      filterOptions: developers,
      filterStyle: FilterStyles.CHECKBOX
    }
  ];

  return (
    <Container>
      <div className="filters-container hide-scrollbar">
        {quickFilters.map(filter => (
          <QuickFilter
            key={filter.filterName}
            filterName={filter.filterName}
            filterType={filter.filterType}
            filterOptions={filter.filterOptions}
            filterStyle={filter.filterStyle}
          />
        ))}
      </div>
    </Container>
  );
};

const Container = styled.div`
  padding: 8px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  overflow-x: auto;
  margin-inline-end: 0;

  .filters-container {
    display: flex;
    flex-direction: row;
    gap: 4px;
    width: 100%;
    margin-top: 0px;
    margin-inline-end: 0;
    overflow-x: auto;
  }

  .sort-btn {
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding: 0 8px;
    height: 80%;
    button {
      font-family: materialMedium;
      background: none;
      border: none;
      outline: none;
      white-space: nowrap;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;
      padding-inline-start: 8px;
      border-inline-start: 1px solid #d1d4d9;
    }
  }
`;

export default QuickFilters;
